import { flushSync } from 'react-dom';
import './theme-transition.css';

let active = false;

/** Commit theme state and DOM together, then reveal the new page snapshot. */
export async function transitionTheme(next, event, updateState) {
  const root = document.documentElement;
  if (active || root.getAttribute('data-theme') === next) return;
  const button = event?.currentTarget;
  const rect = button?.getBoundingClientRect();
  const x = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
  const y = rect ? rect.top + rect.height / 2 : window.innerHeight / 2;
  const radius = Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y));
  const commit = () => {
    flushSync(() => {
      root.setAttribute('data-theme', next);
      updateState(next);
    });
    try { localStorage.setItem('theme', next); } catch { /* Theme still works if storage is unavailable. */ }
  };
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { commit(); return; }
  active = true;
  let committed = false;
  const apply = () => { commit(); committed = true; };
  if (typeof document.startViewTransition === 'function') {
    root.style.setProperty('--fb-theme-x', `${x}px`);
    root.style.setProperty('--fb-theme-y', `${y}px`);
    root.style.setProperty('--fb-theme-radius', `${radius + 12}px`);
    root.classList.add('fb-theme-reveal');
    try {
      const transition = document.startViewTransition(apply);
      // Both promises may reject if a snapshot is skipped; handle immediately.
      const finished = transition.finished.catch(() => {});
      await transition.ready;
      await finished;
    } catch {
      if (!committed) apply();
    } finally {
      root.classList.remove('fb-theme-reveal');
      ['--fb-theme-x', '--fb-theme-y', '--fb-theme-radius'].forEach(property => root.style.removeProperty(property));
      active = false;
    }
  } else {
    root.classList.add('fb-theme-color-transition');
    // Establish the transition styles before changing the palette.
    void root.offsetWidth;
    apply();
    window.setTimeout(() => { root.classList.remove('fb-theme-color-transition'); active = false; }, 1450);
  }
}
